import React from 'react';
import { Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { ValidatedField } from 'react-jhipster';
import { IIban } from 'app/shared/model/iban.model';
import { IQuotation } from 'app/shared/model/quotation.model';
import { isEditable } from 'app/shared/util/quotation-utils';

interface IbanDisplayButtonProps {
  ibanEntity?: IIban;
  quotationEntity?: IQuotation;
  handleIBANModal: (mode: 'ADDING-LATE' | 'EDIT') => void;
}

const IbanDisplayButton: React.FC<IbanDisplayButtonProps> = ({ ibanEntity, quotationEntity, handleIBANModal }) => {
  const maxEditableDays = quotationEntity?.bank?.quotationMaxEditableDays;
  const createdDate = quotationEntity?.createdDate ? new Date(quotationEntity.createdDate) : null;
  const currentDate = new Date();

  if (!ibanEntity) {
    return (
      <Button color="link" className="px-1" style={{ fontSize: '11px', padding: '0 4px' }} onClick={() => handleIBANModal('ADDING-LATE')}>
        <Translate contentKey="comexApp.quotation.addIbanNumber">ADD IBAN NUMBER OF CUSTOMER</Translate>
      </Button>
    );
  }

  return (
    <div>
      <ValidatedField id="ibanNumber" name="ibanNumber" data-cy="ibanNumber" disabled value={ibanEntity?.ibanNumber} />

      <Button
        color="link"
        className="px-1 mt-1"
        style={{ fontSize: '11px', padding: '0 4px' }}
        onClick={() => handleIBANModal('EDIT')}
        disabled={!isEditable(createdDate, maxEditableDays, currentDate)}
      >
        <Translate contentKey="comexApp.quotation.editIbanNumber">EDIT IBAN NUMBER OF CUSTOMER</Translate>
      </Button>
    </div>
  );
};

export default IbanDisplayButton;
